import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { byPrefixAndName } from "@awesome.me/kit-1b5e9f4f9d/icons";
import EditableParagraph from "./EditableParagraph";
import canvasTemplate from "../canvas-template.json";

const StrategyTab = ({
  selectedTab,
  project,
  isPreviewMode,
  onStrategyFieldSelected,
  updateStrategy,
  netlifyIdentity
}) => {
  const getStrategySection = (name) => {
    for (const section of canvasTemplate.sections) {
      if (section.key === name) {
        return section;
      }
      for (const subsection of section.sections) {
        if (subsection.key === name) {
          return subsection;
        }
      }
    }
    return null;
  };

  return (
    <div
      id="strategy-tab-content"
      className={`box handwriting pb-6 ${selectedTab == "strategy-tab" ? "" : "is-hidden"
        }`}
      data-content="2"
      style={{ borderRadius: "0px 10px 10px 10px" }}
    >
      <section className="section content">
        <div className="pt-4"></div>
        <h2 className="subtitle is-size-5 mb-0 has-text-dark has-text-weight-normal pb-0">
          The Big Picture
        </h2>
        <h1 className="title is-1 mt-2 mb-3">{project.name}</h1>
        {!isPreviewMode ? (
          <div className="box has-background-white-ter is-shadowless no-print">
            <FontAwesomeIcon
              className="pr-3"
              icon={byPrefixAndName.fas["circle-1"]}
            />
            Write your mobile strategy here to capture your big decisions.
          </div>
        ) : null}

        <div className="columns mt-3 is-multiline is-mobile">
          <div className="column is-10-widescreen is-12-desktop is-12-mobile is-12-tablet">
            <h4 className="has-text-weight-semibold is-color-info-50">
              <FontAwesomeIcon
                className="pr-2"
                icon={byPrefixAndName.fal["rocket-launch"]}
              />
              Winning Aspiration
            </h4>

            <EditableParagraph
              disabled={isPreviewMode}
              text={project?.strategy?.["winning-aspiration"]}
              className="is-size-3-widescreen is-size-4-desktop is-size-5-tablet is-size-5-mobile has-text-weight-semibold"
              onBlur={(e) =>
                updateStrategy("winning-aspiration", e.target.textContent)
              }
              onHover={(e) =>
                onStrategyFieldSelected
                  ? onStrategyFieldSelected("winning-aspiration")
                  : null
              }
            />
          </div>
          <div className="column is-4"></div>
          <div className="column is-12 mt-3 pb-0">
            <h4 className="has-text-weight-semibold is-color-info-50">
              <FontAwesomeIcon
                className="pr-2"
                icon={byPrefixAndName.fal["location"]}
              />
              Where to Play
            </h4>
          </div>
          <div className="column is-6">
            <h5 className="has-text-weight-light is-size-6">Geography</h5>

            <EditableParagraph
              disabled={isPreviewMode}
              text={project?.strategy?.["geography"]}
              onBlur={(e) =>
                updateStrategy("geography", e.target.textContent)
              }
              onHover={(e) =>
                onStrategyFieldSelected
                  ? onStrategyFieldSelected("geography")
                  : null
              }
            />
          </div>

          <div className="column is-6">
            <h5 className="has-text-weight-light is-size-6 ">Customer</h5>

            <EditableParagraph
              disabled={isPreviewMode}
              text={project?.strategy?.["customer"]}
              onBlur={(e) => updateStrategy("customer", e.target.textContent)}
              onHover={(e) =>
                onStrategyFieldSelected
                  ? onStrategyFieldSelected("customer")
                  : null
              }
            />
          </div>
          <div className="column is-6">
            <h5 className="has-text-weight-light is-size-6">Channel</h5>

            <EditableParagraph
              disabled={isPreviewMode}
              text={project?.strategy?.["channel"]}
              onBlur={(e) => updateStrategy("channel", e.target.textContent)}
              onHover={(e) =>
                onStrategyFieldSelected
                  ? onStrategyFieldSelected("channel")
                  : null
              }
            />
          </div>
          <div className="column is-6">
            <h5 className="has-text-weight-light is-size-6 ">Offer</h5>

            <EditableParagraph
              disabled={isPreviewMode}
              text={project?.strategy?.["offer"]}
              onBlur={(e) => updateStrategy("offer", e.target.textContent)}
              onHover={(e) =>
                onStrategyFieldSelected
                  ? onStrategyFieldSelected("offer")
                  : null
              }
            />
          </div>
          <div className="column is-8">
            <h4 className="has-text-weight-semibold is-color-info-50 pt-6">
              <FontAwesomeIcon
                className="pr-2"
                icon={byPrefixAndName.fal["road"]}
              />
              Capabilities
            </h4>
            <EditableParagraph
              disabled={isPreviewMode}
              text={project?.strategy?.["capabilities"]}
              onBlur={(e) =>
                updateStrategy("capabilities", e.target.textContent)
              }
              onHover={(e) =>
                onStrategyFieldSelected
                  ? onStrategyFieldSelected("capabilities")
                  : null
              }
            />
          </div>
          <div className="column is-8 mt-3">
            <h4 className="has-text-weight-semibold is-color-info-50">
              <FontAwesomeIcon
                className="pr-2"
                icon={byPrefixAndName.fal["trophy"]}
              />
              How to Win
            </h4>
            <EditableParagraph
              disabled={isPreviewMode}
              text={project?.strategy?.["how-to-win"]}
              onBlur={(e) =>
                updateStrategy("how-to-win", e.target.textContent)
              }
              onHover={(e) =>
                onStrategyFieldSelected
                  ? onStrategyFieldSelected("how-to-win")
                  : null
              }
            />
          </div>
          <div className="column is-8 mt-5">
            <h4 className="has-text-weight-semibold is-color-info-50">
              <FontAwesomeIcon
                className="pr-2"
                icon={byPrefixAndName.fal["chart-line-up"]}
              />
              Management Systems
            </h4>
            <EditableParagraph
              disabled={isPreviewMode}
              text={project?.strategy?.["management-systems"]}
              onBlur={(e) =>
                updateStrategy("management-systems", e.target.textContent)
              }
              onHover={(e) =>
                onStrategyFieldSelected
                  ? onStrategyFieldSelected("management-systems")
                  : null
              }
            />
          </div>
          <div className="column is-12 mt-3">
            <hr />
            <h4 className="has-text-weight-semibold is-color-info-50 pt-6">
              <FontAwesomeIcon
                className="pr-2"
                icon={byPrefixAndName.fal["bolt"]}
              />
              What would have to be true for this strategy to work?
            </h4>
          </div>
          <div className="column is-4">
            <h4 className="has-text-weight-light is-size-6">Customers</h4>
            <EditableParagraph
              disabled={isPreviewMode}
              text={project?.strategy?.["wwhtbt-customers"]}
              onBlur={(e) =>
                updateStrategy("wwhtbt-customers", e.target.textContent)
              }
              onHover={(e) =>
                onStrategyFieldSelected
                  ? onStrategyFieldSelected("wwhtbt-customers")
                  : null
              }
            />
          </div>

          <div className="column is-4">
            <h4 className="has-text-weight-light is-size-6">Company</h4>
            <EditableParagraph
              disabled={isPreviewMode}
              text={project?.strategy?.["wwhtbt-company"]}
              onBlur={(e) =>
                updateStrategy("wwhtbt-company", e.target.textContent)
              }
              onHover={(e) =>
                onStrategyFieldSelected
                  ? onStrategyFieldSelected("wwhtbt-company")
                  : null
              }
            />
          </div>
          <div className="column is-4">
            <h4 className="has-text-weight-light is-size-6">Competition</h4>
            <EditableParagraph
              disabled={isPreviewMode}
              text={project?.strategy?.["wwhtbt-competition"]}
              onBlur={(e) =>
                updateStrategy("wwhtbt-competition", e.target.textContent)
              }
              onHover={(e) =>
                onStrategyFieldSelected
                  ? onStrategyFieldSelected("wwhtbt-competition")
                  : null
              }
            />
          </div>
          <div className="column is-12 mt-3">
            <hr />
            <h4 className="has-text-weight-semibold is-color-info-50 pt-6">
              <FontAwesomeIcon
                className="pr-2"
                icon={byPrefixAndName.fal["vial-circle-check"]}
              />
              What are the high-risk assumptions, and how can we test?
            </h4>
          </div>
          <div className="column is-6">
            <h4 className="has-text-weight-light is-size-6">
              High Risk Assumptions
            </h4>
            <EditableParagraph
              disabled={isPreviewMode}
              text={project?.strategy?.["wwhtbt-barriers"]}
              onBlur={(e) =>
                updateStrategy("wwhtbt-barriers", e.target.textContent)
              }
              onHover={(e) =>
                onStrategyFieldSelected
                  ? onStrategyFieldSelected("wwhtbt-barriers")
                  : null
              }
            />
          </div>

          <div className="column is-6">
            <h4 className="has-text-weight-light is-size-6">
              How we'll test them
            </h4>
            <EditableParagraph
              disabled={isPreviewMode}
              text={project?.strategy?.["wwhtbt-tests"]}
              onBlur={(e) =>
                updateStrategy("wwhtbt-tests", e.target.textContent)
              }
              onHover={(e) =>
                onStrategyFieldSelected
                  ? onStrategyFieldSelected("wwhtbt-tests")
                  : null
              }
            />
          </div>
          <div
            className={`column mt-6 is-12 box has-background-white-ter is-shadowless no-print`}
          >
            Struggling with your strategy? We can help you figure it out.
            Check out{" "}
            <a href="https://pocketworks.co.uk/services" target="_blank">
              our mobile strategy services
            </a>
            .
          </div>
        </div>
      </section>
    </div>
  );
};

export default StrategyTab;
